module.exports = require("./wo.d.ts");